import { HttpResponse, http } from 'msw';
import * as XLSX from 'xlsx';

import { environment } from '../../environments/environment';

const env = { ...environment };
const module = env.services.regionalStructure;

const XLSX_CONTENT_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

const buildWorkbook = (rows: unknown[][]): ArrayBuffer => {
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, XLSX.utils.aoa_to_sheet(rows), 'Sheet0');
  return XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
};

const successRows = [
  ['Region Code', 'Region Name', 'Zone Code', 'Zone Name', 'District Code', 'District Name', 'Store Code'],
  ['R01', 'Central', 'Z01', 'Bangkok', 'D01', 'Ratchada', 'CJX12492'],
  ['R01', 'Central', 'Z01', 'Bangkok', 'D02', 'Ladprao', 'CJX12493'],
  ['R02', 'North', 'Z03', 'Chiang Mai', 'D07', 'Muang', 'CJX20881']
];

// Failed requests return the same error file that is attached to the notification email (CJXNEST-7881)
const errorRows = [
  [...successRows[0], 'Remark'],
  [...successRows[1], 'Store Code not found, District Code not found'],
  [...successRows[2], 'Duplicate Store Code']
];

// One row per status so the action menu can be verified against all of them
const listContent = ['AWAITING_VERIFICATION', 'AWAITING_SCHEDULE', 'ACTIVE', 'FAILED', 'EXPIRED', 'CANCELLED'].map(
  (status, index) => ({
    id: `${index + 1}`,
    docNo: status === 'FAILED' ? 'RH26-000004-FAILED' : `RH26-00000${index + 1}`,
    effectiveDate: '2026-08-10',
    status,
    createdDate: '2026-08-03T07:05:00.000Z',
    createdBy: '000031',
    createdByName: 'Mate Tosapon'
  })
);

const listResolver = () =>
  HttpResponse.json({
    content: listContent,
    page: 0,
    size: 20,
    totalElements: listContent.length,
    totalPages: 1,
    first: true,
    last: true,
    hasContent: true,
    numberOfElements: listContent.length,
    empty: false
  });

// Any docNo ending with -FAILED serves the error file so both cases can be verified without BE
const downloadResolver = ({ params }) => {
  const docNo = String(params.docNo ?? '');
  const rows = docNo.endsWith('-FAILED') ? errorRows : successRows;

  return HttpResponse.arrayBuffer(buildWorkbook(rows), {
    headers: { 'Content-Type': XLSX_CONTENT_TYPE }
  });
};

export const handlers = [
  http.get(env.serverUrl + module.url + '/:docNo/download', downloadResolver),
  http.get(env.serverUrl + module.url, listResolver)
];
